import cx from 'classnames';
import {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {UPDATE_DESIGN_OPTIONS} from '~/CreateFabricGreetingCard/reducers/fabricDesign/constants';
import {selectEditingMobile} from '~/CreateFabricGreetingCard/reducers/fabricDesign/selectors';
import {Button} from '~library/atoms/Button';
import {CloseLineIcon} from '~library/svg/CloseLineIcon';
import './EditorContainer.sass';

export const EditorContainer = ({children, scrolls}) => {
  const editingMobile = useSelector(selectEditingMobile);
  const dispatch = useDispatch();

  const onCloseClick = useCallback(() => {
    dispatch({
      type: UPDATE_DESIGN_OPTIONS,
      payload: {editingMobile: false},
    });
  }, [dispatch]);

  if (!editingMobile) {
    return null;
  }

  return (
    <div className="mobile-editor">
      <Button
        className="unstyled-button mobile-editor__close_button"
        onClick={onCloseClick}
        data-qa-id="design-editor-close"
        type="button"
      >
        <CloseLineIcon ratio={0.75} />
      </Button>
      <div
        className={cx('mobile-editor__content', {
          'mobile-editor__content--scrolls': scrolls,
        })}
      >
        {children}
      </div>
    </div>
  );
};
